import script from "./DashboardCustomizePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardCustomizePanel.vue?vue&type=script&setup=true&lang=js"

import "./DashboardCustomizePanel.vue?vue&type=style&index=0&id=74adfb2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74adfb2e"]])

export default __exports__